module.exports = __webpack_public_path__ + "static/img/desckill_detail_bg.0ce5058d.png";